const musicLinksEN = {
    "view": {
        "table": {
            "title": "Your music links list",
            "column": {
                "releaseName": "Release Name",
                "artists": "Artists",
                "owner": "Owner",
                "created": "Created",
                "musicLink": "Music Link",
                "action": "Action"
            },
            "button": {
                "export_csv": "Export CSV"                    
            },
            "placeholder": {
                "search": "Search..."
            },
            "message": {
                "linkCopied": "Link copied to clipboard!"
            }
        },
        "modal": {
            "edit": {
                "header": "Edit {{musicLinkName}}?",
                "body": "Are you sure that you want to edit this music-link?",
            },
            "delete": {
                "header": "Delete {{musicLinkName}}?",
                "body": "Are you sure that you want to delete this music-link?",
            }
        },
        "message": {
            "success": "Music Link has been removed!",
            "error": "Something went wrong! Please refresh page and try again!",
            "mlAllowanceSpent": "You have spent your music link allowance. In order to create more music links please upgrade your account or contact our support team.",
            "subscriptionFeatureUnavailable": "Your current subscription plan does not support this feature. Please <1>upgrade</1> your subscription plan to avail this feature.",
            "subscriptionExpired": "Your subscription has expired. Please <1>resume</1> your subscription to avail this feature.",
            "moduleAccessRestricted": "You don't have access to this module, please contact the support team for further information."
        }
    },
    "add": {
        "title": "Add Music Link",
        "form": {
            "label": {
                "source": "Source",
                "subUser": "Sub-User",
                "release": "Release",
                "artwork": "Artwork",
                "releaseName": "Release Name",
                "upcEan": "UPC/EAN",
                "artistName": "Artist Name",
                "urlPart1": "Url part1",
                "urlPart2": "Url part2",
                "musicLinkUrl": "Your music link URL is",
                "searchBy": "Search By",
                "upcNumber": "UPC Number",
                "storeReleaseUrl": "Store Release URL",
                "colorCustomisation": "Color Customisation",
                "premadeColors": "Premade Colors",
                "customColors": "Custom Colors",
                "buttonStyle": "Button Style",
                "headerBackground": "Header Background",
                "singleColor": "Single Color",
                "gradient": "Gradient",
                "playerControlsColor": "Player Controls Color",
                "titleColor": "Title Color",
                "descriptionColor": "Description Color",
                "buttonColor": "Button Color",
                "buttonHoverColor": "Button Hover Color",
                "buttonTextColor": "Button Text Color"
            },
            "placeholder": {
                "subUser": "Select Sub-user...",
                "release": "Select Release",
                "releaseUpc": "Enter Release UPC/EAN Number i.e. 5055964352523",
                "releaseStoreUrl": "Enter Release Store Url i.e. open.spotify.com/album/4pAD0l5icphM5TC1A4q8Yn or www.deezer.com/en/album/413370367",
                "urlPart1": "Select Url Part 1"
            },
            "help_text": {
                "subUser": "Note: Only use this dropdown if you want to Add Music Link for any of your Sub-users otherwise leave un-selected.",
                "release": "Note: You can only select releases which are <strong>Distributed.</strong>",
                "releaseUpc": "Note: Only use this dropdown if you want to add a Release that is already on Spotify or Deezer.",
                "releaseStoreUrl": "Note: Only use this dropdown if you want to add a Release that is already on Spotify or Deezer."
            },
            "options": {
                "source": {
                    "existingRelease": "Existing Music Link Release",
                    "externalRelease": "External Release"
                },
                "buttonStyle": {
                    "outlined": "Outlined",
                    "filled": "Filled"
                },
            },
            "button": {
                "reset": "Reset",
                "createNew": "Create New?",
                "submit": "Submit"
            },
            "validation": {
                "formInvalid": "Form cannot be submited! Please fill all fields and check errors!",
                "storeUrlRequired": "{{store}} Url is required",
                "storeUrlValid": "Please add a valid {{store}} Url."
            }
        },
        "message": {
            "success": "Music link has been added!",
            "error": "Something went wrong! Please refresh page and try again!",
            "fetchingReleaseDetails": "Fetching Release Details..."
        },
    },
    "update": {
        "title": "Edit Music Link",
        "form": {
            "label": {
                "source": "Source",
                "release": "Release",
                "artwork": "Artwork",
                "releaseName": "Release Name",
                "upcEan": "UPC/EAN",
                "artistName": "Artist Name",
                "urlPart1": "Url part1",
                "urlPart2": "Url part2",
                "musicLinkUrl": "Your music link URL is",
                "searchBy": "Search By",
                "upcNumber": "UPC Number",
                "storeReleaseUrl": "Store Release URL",
                "colorCustomisation": "Color Customisation",
                "premadeColors": "Premade Colors",
                "customColors": "Custom Colors",
                "buttonStyle": "Button Style",
                "headerBackground": "Header Background",
                "singleColor": "Single Color",
                "gradient": "Gradient",
                "playerControlsColor": "Player Controls Color",
                "titleColor": "Title Color",
                "descriptionColor": "Description Color",
                "buttonColor": "Button Color",
                "buttonHoverColor": "Button Hover Color",
                "buttonTextColor": "Button Text Color"
            },
            "placeholder": {
                "release": "Select Release",
                "releaseUpc": "Enter Release UPC/EAN Number i.e. 5055964352523",
                "releaseStoreUrl": "Enter Release Store Url i.e. open.spotify.com/album/4pAD0l5icphM5TC1A4q8Yn or www.deezer.com/en/album/413370367",
                "urlPart1": "Select Url Part 1"
            },
            "help_text": {
                "release": "Note: You can only select releases which are <strong>Distributed.</strong>",
                "releaseUpc": "Note: Only use this dropdown if you want to add a Release that is already on Spotify or Deezer.",
                "releaseStoreUrl": "Note: Only use this dropdown if you want to add a Release that is already on Spotify or Deezer."
            },
            "options": {
                "source": {
                    "existingRelease": "Existing Music Link Release",
                    "externalRelease": "External Release"
                },
                "buttonStyle": {
                    "outlined": "Outlined",
                    "filled": "Filled"
                },
            },
            "button": {
                "reset": "Reset",
                "createNew": "Create New?",
                "submit": "Submit"
            },
            "validation": {
                "formInvalid": "Form cannot be submited! Please fill all fields and check errors!",
                "storeUrlRequired": "{{store}} Url is required",
                "storeUrlValid": "Please add a valid {{store}} Url."
            }
        },
        "message": {
            "success": "Music link has been updated!",
            "error": "Something went wrong! Please refresh page and try again!",
            "fetchingReleaseDetails": "Fetching Release Details..."
        },
    },
    "storeLinksRow": {
        "title": "Store Links",
        "label": {
            "store": "Store",
            "link": "Link"
        },
        "button": {
           "remove": "Remove"
        },
        "model": {
            "addStore": {
                "header": "Add Store",
                "body": "Please choose the desired store from the list below:",
                "option": {
                    "mainStores": "Main Stores",
                    "otherStores": "Other Stores"
                },
                "button": {
                    "add": "Add Store",
                    "cancel": "Cancel"
                }
            }
        }
    },
    "previewFilesRow": {
        "title": "Preview Files",
        "label": {
            "preview": "Preview",
            "artistName": "Artist name",
            "trackName": "Track name"
        },
        "audioNotSupported": "Your browser does not support the audio element."
    },
    "landingPagePreview": {
        "label": {
            "chooseMusicService": "Choose Music Service",
            "track": "Track",
            "artist": "Artist",
            "time": "Time",
            "others": "Others"
        },
        "button": {
            "play": "Play"
        }
    },
    "viewStats": {
        "label": {
            "fetchingStats": "Fetching Stats for Music Link",
        },
        "topServices": {
            "title": "Top Services",
            "subtitle": "CLICK THROUGH BY SERVICE",
            "table": {
                "column": {
                    "store": "Store",
                    "noOfVisits": "Total Visits",
                    "noOfVisitsPct": "Total Visits %",
                },
                "label": {
                    "otherStores": "Other Stores"
                }
            }
        },
        "topTracks": {
            "title": "Top Tracks",
            "subtitle": "CLICK THROUGH BY TRACK",
            "table": {
                "column": {
                    "trackName": "Track Name",
                    "artistName": "Artist Name",
                    "noOfPlays": "No Of Plays",
                    "noOfPlaysPct": "No Of Plays %",
                },
            }
        },
        "topTerritories": {
            "title": "Top Territories",
            "subtitle": "CLICK THROUGH BY TERRITORY",
            "table": {
                "column": {
                    "territory": "Territory",
                    "noOfViews": "No Of Views",
                    "noOfViewsPct": "No Of Views %",
                },
            }
        },
        "topDeviceTypes": {
            "title": "Top Device Types",
            "subtitle": "CLICK THROUGH BY DEVICE TYPE",
        },
        "topOperatingSystems": {
            "title": "Top Operating Systems",
            "subtitle": "CLICK THROUGH BY OS",
            "chart": {
                "label": {
                    "noOfViews": "No Of Views : ",
                    "operatingSystems": "Betriebssystem"
                }
            }
        },
        "topBrowsers": {
            "title": "Top Browsers",
            "subtitle": "CLICK THROUGH BY BROWSER",
            "table": {
                "column": {
                    "browser": "Browser",
                    "noOfViewsPct": "No Of Views (%)",
                },
            }
        }
    }
};

export default musicLinksEN;